export * from './joined-multi-checkbox.component';
